var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuListRestaurant(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnssvg: "http://www.w3.org/2000/svg",
    id: "svg885",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs889",
    fill: "#246abf"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath899",
    fill: "#246abf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,24 H 24 V 0 H 0 Z",
    id: "path897",
    fill: "#246abf"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g891",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,32)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g893"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g895",
    clipPath: "url(#clipPath899)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g901",
    transform: "translate(17.5,1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v 20.051 c 0,0.968 1.098,1.25 1.807,0.592 C 3.23,19.321 5,16.5 5,12.5 5,6.5 0,3.233 0,3.233",
    className: "path-style-restaurant"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g905",
    transform: "translate(6.5,22.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -21",
    className: "path-style-restaurant"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g909",
    transform: "translate(11.5,22.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -6 c 0,-2.762 -2.238,-5 -5,-5 -2.762,0 -5,2.238 -5,5 v 6",
    className: "path-style-restaurant"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuListRestaurant);
export default __webpack_public_path__ + "static/media/menu_list-restaurant.a818c4c7f38226edcff51df2f425bdcc.svg";
export { ForwardRef as ReactComponent };